import React from "react";
import classNames from "classnames";
import styles from "../FormField.module.scss";

export interface IFioFieldProps {
  id?: string;
  error?: string;
  name?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

export const FioFormField: React.FC<IFioFieldProps> = ({
  id,
  error,
  name,
  readOnly = false,
  registerField,
  isFocused,
  onFocus,
  onBlur,
  checksPresenceName,
  autoComplete,
}) => {
  const PATTERN = /[^А-Яа-яЁё -]/g;

  const getInputFioValue = (value: string) => {
    return value.replace(PATTERN, "");
  };

  const handleFioInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    const input = e.target;
    const inputFioValue = getInputFioValue(input.value);
    input.value = inputFioValue;
  };

  const handleFioPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData ?? window["clipboardData"];
    const input = e.target as HTMLInputElement;
    const inputFioValue = getInputFioValue(input.value);

    if (pasted) {
      const pastedText = pasted.getData("Text");
      if (PATTERN.test(pastedText)) {
        input.value = inputFioValue;
      }
    }
  };

  return (
    <input
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      name={name}
      type="text"
      readOnly={readOnly}
      onInput={handleFioInput}
      onPaste={handleFioPaste}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={autoComplete}
    />
  );
};
